import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import ReportService from '../../../../common/order/factSheetReport/store/ReportService'
import UserManagementService from '../../../store/services/UserManagementService'

export const getUserPricingPackagesPaged = createAsyncThunk(
  'userManagement/getUserPricingPackagesPaged',
  async (params, { rejectWithValue }) => {
    try {
      const response = await UserManagementService.getUserPricingPackagesPaged(
        params,
      )
      if (response.success) return response
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getFiinGateReportTypes = createAsyncThunk(
  'userManagement/getFiinGateReportTypes',
  async (params, { rejectWithValue }) => {
    try {
      const response = await ReportService.getFiinGateReportTypes(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
